<template>
  <el-main
    class="pageStudentDetail"
    style="padding: 0"
  >
    <div class="navs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{path:'/front'}">
          <a>用户管理</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item :to="{path:'/score_detail'}">代理小煜详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div
      class="backPage"
      @click="pageBack"
    >
      <el-button
        icon="el-icon-arrow-left"
        plain
      >返回</el-button>
    </div>
    <div class="clientContent">
      <div
        v-loading="loading"
        class="paraContent_body"
      >
        <div
          v-if="stu != null"
          class="stuDetailContent0"
        >
          <div class="stuDetailContent1">
            <div class="userHead">
              <img
                :src="stu.user_head"
                alt
              />
              <div>
                <span style="margin-right:10px">{{stu.username}}</span>
                <!-- <span v-if="stu.sex == 1" style="color:blue">男</span>
                <span v-if="stu.sex == 2" style="color:red">女</span> -->
              </div>

              <div>
                <span
                  v-if="stu.role_type == 3"
                  style="color:green"
                >董事</span>
              </div>
            </div>
            <div class="userInfo">

              <div class="moreUserInfo">
                <div class="base_label">基本信息</div>
                <ul>
                  <li>
                    <font class="colorC fontWidth">联系电话：</font>
                    {{stu.telephone}}
                  </li>
                  <li>
                    <font class="colorC fontWidth">姓名：</font>
                    {{stu.username}}
                  </li>
                </ul>
              </div>

              <div class="moreUserInfo">
                <div class="base_label">资金信息</div>
                <ul>
                  <li v-show="stu.rank != -1">
                    <font class="colorC fontWidth">同级别排名：</font>
                    {{stu.rank}}
                  </li>
                  <li>
                    <font class="colorC fontWidth">团队小煜：</font>
                    {{stu.my_score}}
                  </li>

                  <li>
                    <font class="colorC fontWidth">直属小煜：</font>
                    <span style="margin-right:5px">{{stu.direct_score}}</span>
                  </li>
                  <li>
                    <font class="colorC fontWidth">团队成员待转小煜：</font>
                    <span style="margin-right:5px">{{stu.group_score}}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

        </div>
        <div class="stuDetailContent2">
          <el-tabs
            v-model="activeName"
            @tab-click="handleClick"
          >

            <el-tab-pane
              label="同级直属"
              name="yeji"
            >
              <div class="contain_div">
                <div class="contain_header clr">
                  <el-form
                    :inline="true"
                    class="m-search"
                    size="small"
                    :model="filtersY"
                  >

                    <el-form-item>
                      <el-button
                        type="primary"
                        @click="handleSearchYeji"
                      >搜索</el-button>
                    </el-form-item>
                  </el-form>
                </div>

                <div class="contain_body">
                  <el-table
                    v-loading="listLoadingY"
                    :data="tableDataY"
                    style="width: 100%"
                    :header-cell-class-name="objectSpanMethod"
                  >
                    <el-table-column
                      prop="username"
                      label="代理姓名"
                    ></el-table-column>

                    <el-table-column label="代理头像">
                      <template slot-scope="scope">
                        <img
                          :src="scope.row.user_head"
                          style="width:50px;height:50px"
                        />
                      </template>
                    </el-table-column>

                    <el-table-column
                      prop="role_type"
                      :formatter="formatterRoleType"
                      label="代理类型"
                    ></el-table-column>
                    <el-table-column
                      prop="telephone"
                      label="代理手机"
                    ></el-table-column>
                    <el-table-column
                      prop="group_score"
                      label="代理团队小煜"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="direct_score"
                      label="代理直属小煜"
                    >
                    </el-table-column>

                    <el-table-column
                      prop="in_money"
                      label="本月销售箱数"
                    ></el-table-column>

                    <el-table-column
                      prop="one_base_in_money"
                      label="本月销售金额"
                    ></el-table-column>
                  </el-table>
                  <div class="pageDiv block">
                    <el-pagination
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChangeY"
                      :current-page.sync="page_num1Y"
                      :page-count="total_page1Y"
                      :page-size="page_size1Y"
                      layout="total, prev, pager, next"
                      :total="total_num1Y"
                    ></el-pagination>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane
              label="同级非直属"
              name="third"
            >
              <div class="contain_div">
                <div class="contain_header clr">
                  <el-form
                    :inline="true"
                    class="m-search"
                    size="small"
                    :model="filtersY"
                  >
                    <el-form-item>
                      <el-button
                        type="primary"
                        @click="selectBank"
                      >搜索</el-button>
                    </el-form-item>
                  </el-form>
                </div>
                <div class="contain_body">
                  <el-table
                    v-loading="listLoading2Y"
                    :data="tableData2Y"
                    style="width: 100%"
                    :header-cell-class-name="objectSpanMethod"
                  >
                    <el-table-column
                      prop="username"
                      label="代理姓名"
                    ></el-table-column>

                    <el-table-column label="代理头像">
                      <template slot-scope="scope">
                        <img
                          :src="scope.row.user_head"
                          style="width:50px;height:50px"
                        />
                      </template>
                    </el-table-column>

                    <el-table-column
                      prop="role_type"
                      :formatter="formatterRoleType"
                      label="代理类型"
                    ></el-table-column>
                    <el-table-column
                      prop="telephone"
                      label="代理手机"
                    ></el-table-column>
                    <el-table-column
                      prop="group_score"
                      label="代理团队小煜"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="direct_score"
                      label="代理直属小煜"
                    >
                    </el-table-column>

                    <el-table-column
                      prop="in_money"
                      label="本月销售箱数"
                    ></el-table-column>

                    <el-table-column
                      prop="one_base_in_money"
                      label="本月销售金额"
                    ></el-table-column>
                  </el-table>
                  <div class="pageDiv block">
                    <el-pagination
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChange"
                      :current-page.sync="page_num2Y"
                      :page-count="total_page2Y"
                      :page-size="page_size2Y"
                      layout="total, prev, pager, next"
                      :total="total_num2Y"
                    ></el-pagination>
                  </div>
                </div>
              </div>
            </el-tab-pane>

            <el-tab-pane
              label="团队返利小煜交易明细"
              name="four"
            >
              <div class="contain_div">
                <div class="contain_header clr">
                  <el-form
                    :inline="true"
                    class="m-search"
                    size="small"
                    :model="filtersOut"
                  >
                    <el-form-item label="查询月份">
                      <el-date-picker
                        type="month"
                        placeholder="选择年月"
                        v-model="filtersOut.endTime"
                        style="width: 100%;"
                      ></el-date-picker>
                    </el-form-item>
                    <el-form-item>
                      <el-button
                        type="primary"
                        @click="handleSearch"
                      >搜索</el-button>
                    </el-form-item>
                  </el-form>
                </div>

                <div class="contain_body">
                  <el-table
                    v-loading="listLoadingOut"
                    :data="tableDataOut"
                    style="width: 100%"
                    :header-cell-class-name="objectSpanMethod"
                  >
                    <el-table-column
                      prop="score"
                      label="积分"
                    >
                      <template slot-scope="scope">
                        <span v-if="scope.row.second_type == 1">+{{scope.row.score}}</span>
                        <span v-if="scope.row.second_type == 4">-{{scope.row.score}}</span>
                        <span v-if="scope.row.second_type == 5">+{{scope.row.score}}</span>
                        <span v-if="scope.row.second_type == 6">+{{scope.row.score}}</span>
                        <span v-if="scope.row.second_type == 7">-{{scope.row.score}}</span>
                        <span v-if="scope.row.second_type == 8">-{{scope.row.score}}</span>
                        <span v-if="scope.row.second_type == 9">+{{scope.row.score}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="username"
                      label="类型"
                    >
                      <template slot-scope="scope">
                        <span v-if="scope.row.second_type == 1">直属下单返利</span>
                        <span v-if="scope.row.second_type == 4">提现转出直属</span>
                        <span v-if="scope.row.second_type == 5">月度业绩提成获得团队小煜</span>
                        <span v-if="scope.row.second_type == 6">下级转入团队小煜</span>
                        <span v-if="scope.row.second_type == 7">转出给上级团队小煜</span>
                        <span v-if="scope.row.second_type == 8">提现转出团队小煜</span>
                        <span v-if="scope.row.second_type == 9">非直属下单返利</span>
                      </template>
                    </el-table-column>

                    <el-table-column
                      prop="total_money"
                      width="500"
                      label="描述"
                    >
                      <template slot-scope="scope">
                        <div v-if="scope.row.second_type == 1">
                          获得来自下级{{scope.row.by_name}}下的订单<span>{{scope.row.order_code}}</span>获得直属返利，比例是{{scope.row.sale_rate}}
                        </div>
                        <div v-if="scope.row.second_type == 9">
                          获得来自下下级{{scope.row.by_name}}下的订单<span>{{scope.row.order_code}}</span>获得非直属返利，比例是{{scope.row.sale_rate}}
                        </div>
                        <div v-if="scope.row.second_type == 4">
                          提现直属小煜{{scope.row.score}}：
                          <div v-if="scope.row.info_type == 1">银行：<br />银行名称：{{scope.row.bank_name}}<br />开户行：{{scope.row.open_bank}}<br />卡号：{{scope.row.bank_code}}<br />{{scope.row.bank_username}}</div>
                          <div v-if="scope.row.info_type == 2">支付宝：<br />真实姓名：{{scope.row.zhi_name}}<br />帐号：{{scope.row.zhi_account}}<br /></div>
                        </div>
                        <div v-if="scope.row.second_type == 5">
                          {{scope.row.create_time_month}}的月度返利是：{{scope.row.score}}，公式如下：
                          <div>
                            销售业绩：{{scope.row.sale_money}} * 提成比例：{{scope.row.sale_rate}} - 下级返利:{{scope.row.other_money}}<br />
                            <div v-if="scope.row.other_info != null && scope.row.other_info != ''">
                              <div v-for="item in scope.row.other_info" v-bind:key='item'>
                              <span>{{item.username}}获得收益：{{item.money}}</span>
                            </div>
                            </div>
                          </div>
                        </div>
                        <span v-if="scope.row.second_type == 6">来自下级{{scope.row.by_name}}转入团队小煜{{scope.row.score}}</span>
                        <span v-if="scope.row.second_type == 7">转出给上级{{scope.row.by_name}}团队小煜{{scope.row.score}}</span>
                        <div v-if="scope.row.second_type == 8">
                          提现转出团队小煜{{scope.row.score}}:
                          <div v-if="scope.row.info_type == 1">银行：<br />银行名称：{{scope.row.bank_name}}<br />开户行：{{scope.row.open_bank}}<br />卡号：{{scope.row.bank_code}}<br />{{scope.row.bank_username}}</div>
                          <div v-if="scope.row.info_type == 2">支付宝：<br />真实姓名：{{scope.row.zhi_name}}<br />帐号：{{scope.row.zhi_account}}<br /></div>

                        </div>
                      </template>
                    </el-table-column>

                    <el-table-column
                      prop="create_time_form"
                      label="创建时间"
                    ></el-table-column>

                    <el-table-column
                      prop="status"
                      label="审核状态"
                    >
                      <template slot-scope="scope">
                        <el-tag
                          v-if="scope.row.status == 2"
                          type="success"
                          disable-transitions
                        >审核成功</el-tag>
                        <el-tag
                          v-if="scope.row.status == 1"
                          disable-transitions
                        >审核中</el-tag>
                        <el-tag
                          v-if="scope.row.status == 3"
                          type="danger"
                          disable-transitions
                        >审核失败</el-tag>
                      </template>
                    </el-table-column>
                  </el-table>
                  <div class="pageDiv block">
                    <el-pagination
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChange"
                      :current-page.sync="page_num11"
                      :page-count="total_page11"
                      :page-size="page_size11"
                      layout="total, prev, pager, next"
                      :total="total_num11"
                    ></el-pagination>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane
              label="直属小煜交易明细"
              name="fifth"
            >
              <div class="contain_div">
                <div class="contain_header clr">
                  <el-form
                    :inline="true"
                    class="m-search"
                    size="small"
                    :model="filtersOrder"
                  >
                    <el-form-item label="查询月份">
                      <el-date-picker
                        type="month"
                        placeholder="选择年月"
                        v-model="filtersOrder.endTime"
                        style="width: 100%;"
                      ></el-date-picker>
                    </el-form-item>

                    <el-form-item>
                      <el-button
                        type="primary"
                        @click="handleSearchOrder"
                      >搜索</el-button>
                    </el-form-item>
                  </el-form>
                </div>

                <div class="contain_body">
                  <!-- <div class="contain_body_head">
                    消费总金额：{{useTotal}}
                  </div>-->
                  <el-table
                    v-loading="listLoading3"
                    :data="tableData4"
                    style="width: 100%"
                    :header-cell-class-name="objectSpanMethod"
                  >
                    <el-table-column
                      prop="score"
                      label="积分"
                    >
                      <template slot-scope="scope">
                        <span v-if="scope.row.second_type == 1">+{{scope.row.score}}</span>
                        <span v-if="scope.row.second_type == 4">-{{scope.row.score}}</span>
                        <span v-if="scope.row.second_type == 5">+{{scope.row.score}}</span>
                        <span v-if="scope.row.second_type == 6">+{{scope.row.score}}</span>
                        <span v-if="scope.row.second_type == 7">-{{scope.row.score}}</span>
                        <span v-if="scope.row.second_type == 8">-{{scope.row.score}}</span>
                        <span v-if="scope.row.second_type == 9">-{{scope.row.score}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="username"
                      label="类型"
                    >
                      <template slot-scope="scope">
                        <span v-if="scope.row.second_type == 1">直属下单返利</span>
                        <span v-if="scope.row.second_type == 9">非直属下单返利</span>
                        <span v-if="scope.row.second_type == 4">提现转出直属</span>
                        <span v-if="scope.row.second_type == 5">月度业绩提成获得团队小煜</span>
                        <span v-if="scope.row.second_type == 6">下级转入团队小煜</span>
                        <span v-if="scope.row.second_type == 7">转出给上级团队小煜</span>
                        <span v-if="scope.row.second_type == 8">提现转出团队小煜</span>
                      </template>
                    </el-table-column>

                    <el-table-column
                      prop="total_money"
                      width="500"
                      label="描述"
                    >
                      <template slot-scope="scope">
                        <div v-if="scope.row.second_type == 1">
                          获得来自下级{{scope.row.by_name}}下的订单<span>{{scope.row.order_code}}</span>获得直属返利，比例是{{scope.row.sale_rate}}
                        </div>
                        <div v-if="scope.row.second_type == 9">
                          获得来自下下级{{scope.row.by_name}}下的订单<span>{{scope.row.order_code}}</span>获得非直属返利，比例是{{scope.row.sale_rate}}
                        </div>
                        <div v-if="scope.row.second_type == 4">
                          提现直属小煜{{scope.row.score}}：
                          <div v-if="scope.row.info_type == 1">银行：<br />银行名称：{{scope.row.bank_name}}<br />开户行：{{scope.row.open_bank}}<br />卡号：{{scope.row.bank_code}}<br />{{scope.row.bank_username}}</div>
                          <div v-if="scope.row.info_type == 2">支付宝：<br />真实姓名：{{scope.row.zhi_name}}<br />帐号：{{scope.row.zhi_account}}<br /></div>
                        </div>
                        <div v-if="scope.row.second_type == 5">
                          {{scope.row.create_time_month}}的月度返利是：{{scope.row.score}}，公式如下：
                          <div>
                            销售业绩：{{scope.row.sale_money}} * 提成比例：{{scope.row.sale_rate}} - 下级返利:{{scope.row.other_money}}
                          </div>
                        </div>
                        <span v-if="scope.row.second_type == 6">来自下级{{scope.row.by_name}}转入团队小煜{{scope.row.score}}</span>
                        <span v-if="scope.row.second_type == 7">转出给上级{{scope.row.by_name}}团队小煜{{scope.row.score}}</span>
                        <div v-if="scope.row.second_type == 8">
                          提现转出团队小煜{{scope.row.score}}:
                          <div v-if="scope.row.info_type == 1">银行：<br />银行名称：{{scope.row.bank_name}}<br />开户行：{{scope.row.open_bank}}<br />卡号：{{scope.row.bank_code}}<br />{{scope.row.bank_username}}</div>
                          <div v-if="scope.row.info_type == 2">支付宝：<br />真实姓名：{{scope.row.zhi_name}}<br />帐号：{{scope.row.zhi_account}}<br /></div>

                        </div>
                      </template>
                    </el-table-column>

                    <el-table-column
                      prop="create_time_form"
                      label="创建时间"
                    ></el-table-column>

                    <el-table-column
                      prop="status"
                      label="审核状态"
                    >
                      <template slot-scope="scope">
                        <el-tag
                          v-if="scope.row.status == 2"
                          type="success"
                          disable-transitions
                        >审核成功</el-tag>
                        <el-tag
                          v-if="scope.row.status == 1"
                          disable-transitions
                        >审核中</el-tag>
                        <el-tag
                          v-if="scope.row.status == 3"
                          type="danger"
                          disable-transitions
                        >审核失败</el-tag>
                      </template>
                    </el-table-column>
                  </el-table>
                  <div class="pageDiv block">
                    <el-pagination
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChangeOrde"
                      :current-page.sync="page_num5"
                      :page-count="total_page5"
                      :page-size="page_size5"
                      layout="total, prev, pager, next"
                      :total="total_num5"
                    ></el-pagination>
                  </div>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
    <el-dialog
      title="订单详情"
      :visible.sync="subListVisible"
      width="50%"
    >
      <div class="contain_body_head">购进商品列表</div>
      <el-table
        v-loading="subListLoading"
        :data="subList"
        style="width: 100%"
        :header-cell-class-name="objectSpanMethod"
      >
        <el-table-column
          prop="good_name"
          label="商品名称"
        ></el-table-column>

        <el-table-column label="商品图片">
          <template slot-scope="scope">
            <img
              :src="scope.row.list_pic"
              style="width:50px;"
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="good_price"
          label="原价"
        ></el-table-column>

        <el-table-column
          prop="proxy_price"
          label="代理价"
        ></el-table-column>

        <el-table-column
          prop="num"
          label="购买数量"
        ></el-table-column>
      </el-table>
      <div style="height:10px;width:10px"></div>
      <div
        class="contain_body_head"
        v-show="buList.length > 0"
      >补货商品列表</div>
      <div v-show="buList.length > 0">
        <div
          v-for="item in buList"
          v-bind:key="item.id"
        >
          <div class="contain_body_head">{{item.order_code}},总金额：{{item.total_money}}元</div>
          <el-table
            v-loading="subListLoading"
            :data="item.sub"
            style="width: 100%"
            :header-cell-class-name="objectSpanMethod"
          >
            <el-table-column
              prop="good_name"
              label="商品名称"
            ></el-table-column>

            <el-table-column label="商品图片">
              <template slot-scope="scope">
                <img
                  :src="scope.row.list_pic"
                  style="width:50px;"
                />
              </template>
            </el-table-column>
            <el-table-column
              prop="good_price"
              label="原价"
            ></el-table-column>

            <el-table-column
              prop="proxy_price"
              label="代理价"
            ></el-table-column>

            <el-table-column
              prop="num"
              label="购买数量"
            ></el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="修改库存数量"
      :visible.sync="dialogEditVisible"
      width="20%"
    >
      <el-form
        label-position="top"
        class="m-search"
        size="small"
        :model="editGoodNumForm"
        ref="editGoodNumForm"
      >
        <el-form-item
          label="类型"
          prop="type"
        >
          <el-select
            v-model="editGoodNumForm.type"
            placeholder="请选择"
          >
            <el-option
              label="加"
              value="1"
            ></el-option>
            <el-option
              label="减"
              value="2"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="数量"
          prop="goodNum"
        >
          <el-input
            v-model="editGoodNumForm.goodNum"
            oninput="value=value.replace(/[^\d]/g,'')"
            placeholder="请输入整数"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="备注"
          prop="goodNum"
        >
          <el-input v-model="editGoodNumForm.commend"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="throwGroupUp()"
            :loading="editNumLoading"
          >提交</el-button>
          <el-button @click="dialogEditVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </el-main>
</template>

<script>
import { bus } from "../../bus.js";
import API from "../../api/api_user";
import { dateFunc } from "../../dateFunc.js";
export default {
  name: "score_detail",
  components: {},
  data() {
    return {
      editNumLoading: false,
      subListLoading: false,
      subListVisible: false,
      subListLoading: false,
      editGoodNumForm: {
        goodId: null,
        good_name: null,
        userId: null,
        commend: null,
        goodNum: null,
        type: "1",
        goodId: null
      },
      dialogEditVisible: false,
      infoType: null,
      inTotal: 0,
      outTotal: 0,
      rewardTotal: 0,
      listLoadingY: false,
      useTotal: 0,
      groupCount: {},
      listLoadingOut: false,
      tableDataOut: [],
      filtersIn: {
        startTime: null,
        endTime: null,
        status: null
      },
      filtersOut: {
        startTime: null,
        endTime: null,
        status: null
      },
      yejiMap: {},
      filtersY: {
        month: null,
        type: null
      },
      tableData4: [],
      filtersOrder: {
        startTime: null,
        endTime: null
      },
      filtersReward: {
        startTime: null,
        orderType: "1",
        endTime: null
      },
      tableDataGroup: [],
      page_num: 1,
      keywords: "",
      total_num: 0,
      total_page: 0,
      page_size: 10,
      listLoading1: false,
      listLoading2: false,
      listLoading3: false,

      page_num1Y: 1,
      total_num1Y: 0,
      total_page1Y: 0,
      page_size1Y: 10,
      tableDataY: [],

      page_num11: 1,
      total_num11: 0,
      total_page11: 0,
      page_size11: 10,

      page_num5: 1,
      total_num5: 0,
      total_page5: 0,
      page_size5: 10,
      page_num4: 1,
      total_num4: 0,
      total_page4: 0,
      page_size4: 10,
      page_num3: 1,
      total_num3: 0,
      total_page3: 0,
      page_size3: 10,

      page_num2: 1,
      total_num2: 0,
      total_page2: 0,
      page_size2: 10,

      listLoading255: false,

      page_num3G: 1,
      total_num3G: 0,
      total_page3G: 0,
      page_size3G: 10,
      tableData2G: [],

      page_num3: 1,
      total_num3: 0,
      total_page3: 0,
      page_size3: 10,

      page_num1: 1,
      total_num1: 0,
      total_page1: 0,
      page_size1: 10,
      value1: null,
      CourseGrades: [],
      highScools: [],
      baseFormRule: {},
      filters: {
        status: null,
        startTime: null,
        userId: null,
        endTime: null
      },
      groupMap: {},
      filtersGroup: {
        type: "1",
        roleType: null,
        username: null,
        subId: null
      },
      baseForm: {
        sex: "1",
        username: null,
        fromSchool: null,
        grade: null,
        birthdayTime1: null,
        idCode: null,
        wechatCode: null,
        nation: null,
        fromSchoolClassName: null,
        qqCode: null,
        livePlace: null,
        commend: null
      },
      loading: false,
      tels: [
        {
          name: "联系电话",
          remark: "",
          term: ""
        }
      ],

      dialogFollow: false,
      othSchools: [],
      othSchools1: null,
      powers: "",
      stu: null,
      page_num2Y: 1,
      total_num2Y: 0,
      total_page2Y: 0,
      page_size2Y: 10,
      listLoading2Y: false,
      tableData2Y: [],
      userId: null,
      username: null,
      img: null,
      // img: require("../../assets/img/head.png"),
      num1: 0,
      tags: [
        { index: 0, name: "拉丁舞", id: 0, status: true },
        { index: 1, name: "素描画", id: 1, status: false },
        { index: 2, name: "民族舞", id: 2, status: true }
      ],
      activeName: "yeji",
      bankListVisible: false,
      tableData33: [],
      bankListVisibleLoading: false,
      tableData: [],
      addVisibleLoading: false,
      tableData2: [],
      tableData1: [],
      countInfo: {},
      orderData: [],
      recordData: [],
      AchieveData: [],
      folderData: [],
      listLoading: false,
      accountData: [],
      tel: null,
      relation: null,
      subList: [],
      buList: [],
      remain_money: null,
      backNum: null,
      get_group_user_countLoading: false
    };
  },
  created() {
    var that = this;
    var user = JSON.parse(this.$route.query.user);
    console.info(user);
    this.userId = user.id;
    API.my_inner_score({
      token: localStorage.getItem("api_token"),
      id: this.userId
    })
      .then(
        function(result) {
          that.addLoading = false;
          if (result.key == 1000) {
            that.stu = result.result.map;
            that.stu.telephone = user.telephone;
            that.stu.username = user.username;
            that.stu.user_head = user.user_head;
            // that.stu.create_time = dateFunc.formatDate(
            //   new Date(parseInt(that.stu.create_time)),
            //   "yyyy-MM-dd hh:mm:ss"
            // );

            if (that.activeName == "yeji") {
              that.handleSearchYeji();
            } else if (that.activeName == "cangku") {
              that.handleSearchGoodList();
            } else if (that.activeName == "second") {
              // this.get_group_user_count();
            } else if (that.activeName == "four_ua") {
              that.selectAddress();
            } else if (that.activeName == "third") {
              that.selectBank();
            } else if (that.activeName == "three") {
              that.handleSearchIn();
            } else if (that.activeName == "four") {
              that.handleSearch();
            } else if (that.activeName == "fifth") {
              that.handleSearchOrder();
              // 订单消费记录;
            } else if (that.activeName == "six") {
              that.handleSearchReward();
              // 打赏记录;
            } else if (that.activeName == "seven") {
              that.handleSearchGroup(); //我的团队
            }
          } else {
            that.$message.error({
              showClose: true,
              message: result.message || "登录失败",
              duration: 2000
            });
          }
        },
        function(err) {
          that.loading = false;
          console.error(err);
          that.$message.error({
            showClose: true,
            message: err.toString(),
            duration: 2000
          });
        }
      )
      .catch(function(error) {
        that.loading = false;
        console.error(error);
        that.$message.error({
          showClose: true,
          message: "请求出现异常",
          duration: 2000
        });
      });
    //cangku
  },
  mounted() {},
  methods: {
    showOrderDetail(row) {
      let that = this;
      that.subListVisible = true;
      that.subListLoading = true;
      let para = {
        token: localStorage.getItem("api_token"),
        id: row.id
      };
      API.good_order_detail(para)
        .then(
          function(result) {
            that.subListLoading = false;
            if (result && parseInt(result.key) === 1000) {
              that.subList = result.result.map.sub;
              if (result.result.map.orders != null) {
                that.buList = result.result.map.orders;
              } else {
                that.buList = [];
              }
            }
          },
          function(err) {
            that.subListLoading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.subListLoading = false;
          console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    showEditForm(row) {
      this.editGoodNumForm.type = "1";
      this.editGoodNumForm.goodNum = 0;
      this.editGoodNumForm.goodId = row.good_id;
      this.editGoodNumForm.good_name = row.good_name;
      this.dialogEditVisible = true;
    },
    throwGroupUp() {
      var that = this;
      if (!that.editGoodNumForm.type || that.editGoodNumForm.type == null) {
        that.$message.error({
          showClose: true,
          message: "请选择操作类型",
          duration: 2000
        });
      } else if (
        !that.editGoodNumForm.goodNum ||
        that.editGoodNumForm.goodNum == null
      ) {
        that.$message.error({
          showClose: true,
          message: "请输入操作数量",
          duration: 2000
        });
      } else {
        that.editNumLoading = true;
        let para = {
          token: localStorage.getItem("api_token"),
          userId: that.userId,
          op_time: new Date().getTime(),
          goods: JSON.stringify([
            {
              infoId: that.editGoodNumForm.goodId,
              goodNum: that.editGoodNumForm.goodNum,
              commend: that.editGoodNumForm.commend,
              title: that.editGoodNumForm.good_name
            }
          ]),
          type: that.editGoodNumForm.type
        };
        API.add_user_stock(para)
          .then(
            function(result) {
              that.editNumLoading = false;
              if (result && parseInt(result.key) === 1000) {
                that.$message.success({
                  showClose: true,
                  message: "申请成功",
                  duration: 1500
                });
                that.dialogEditVisible = false;
                that.searchGoodList();
              }
            },
            function(err) {
              that.editNumLoading = false;
              that.$message.error({
                showClose: true,
                message: err.toString(),
                duration: 2000
              });
            }
          )
          .catch(function(error) {
            that.editNumLoading = false;
            console.log(error);
            that.$message.error({
              showClose: true,
              message: "请求出现异常",
              duration: 2000
            });
          });
      }
    },
    formatterOrderType(row, column) {
      if (row.order_type == 1) {
        return "发货订单";
      } else if (row.order_type == 2) {
        return "购进订单";
      } else if (row.order_type == 3) {
        return "待补货订单";
      } else if (row.order_type == 4) {
        return "已补货订单";
      }
    },
    formatterRoleType(row, column) {
      if (row.role_type == -1) {
        return "无";
      } else if (row.role_type == 1) {
        return "经理";
      } else if (row.role_type == 2) {
        return "总经理";
      } else if (row.role_type == 3) {
        return "董事";
      } else if (row.role_type == 4) {
        return "CEO";
      }
       else if (row.role_type == 5) {
        return "总经销商";
      }
    },
    excelOut() {
      var that = this;
      var url =
        "/manager/user/pc/my_group_excel?token=" +
        localStorage.getItem("api_token");
      url = url + "&subId=" + this.userId;
      if (that.filtersGroup.groupType) {
        url = url + "&groupType=" + that.filtersGroup.groupType;
      }
      if (that.filtersGroup.isAll) {
        url = url + "&isAll=" + that.filtersGroup.isAll;
      }
      if (that.filtersGroup.keyword) {
        url = url + "&keyword=" + that.filtersGroup.keyword;
      }
      top.location.href = url;
    },

    excelOut2() {
      var that = this;
      var url =
        "/manager/user/pc/reward_excel?token=" +
        localStorage.getItem("api_token");
      url = url + "&userId=" + this.userId;
      if (that.filtersGroup.startTime) {
        url = url + "&startTime=" + that.filtersReward.startTime.getTime();
      }
      if (that.filtersGroup.endTime) {
        url = url + "&endTime=" + that.filtersReward.endTime.getTime();
      }
      top.location.href = url;
    },
    upHouseStatus(row, status) {
      if (status == 3) {
        let that = this;
        this.$confirm("确定拒绝吗?", "提示", { type: "info" })
          .then(() => {
            that.loading = true;
            let para = {
              token: localStorage.getItem("api_token"),
              inId: row.id,
              status: 3
            };
            API.up_charge(para)
              .then(
                function(result) {
                  that.loading = false;
                  if (result && parseInt(result.key) === 1000) {
                    that.$message.success({
                      showClose: true,
                      message: "拒绝成功",
                      duration: 1500
                    });
                    that.searchIn();
                  }
                },
                function(err) {
                  that.loading = false;
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000
                  });
                }
              )
              .catch(function(error) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
          })
          .catch(() => {});
      } else if (status == 2) {
        let that = this;
        this.$confirm("确定通过该审核吗?", "提示", { type: "info" })
          .then(() => {
            that.loading = true;
            let para = {
              token: localStorage.getItem("api_token"),
              inId: row.id,
              status: 2
            };
            API.up_charge(para)
              .then(
                function(result) {
                  that.loading = false;
                  if (result && parseInt(result.key) === 1000) {
                    that.$message.success({
                      showClose: true,
                      message: "通过成功",
                      duration: 1500
                    });
                    that.search();
                  }
                },
                function(err) {
                  that.loading = false;
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000
                  });
                }
              )
              .catch(function(error) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
          })
          .catch(() => {});
      }
    },
    upHouseStatusOut(row, status) {
      if (status == 3) {
        let that = this;
        this.$confirm("确定拒绝吗?", "提示", { type: "info" })
          .then(() => {
            that.loading = true;
            let para = {
              token: localStorage.getItem("api_token"),
              outId: row.id,
              status: 3
            };
            API.up_cash_out(para)
              .then(
                function(result) {
                  that.loading = false;
                  if (result && parseInt(result.key) === 1000) {
                    that.$message.success({
                      showClose: true,
                      message: "拒绝成功",
                      duration: 1500
                    });
                    that.search();
                  }
                },
                function(err) {
                  that.loading = false;
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000
                  });
                }
              )
              .catch(function(error) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
          })
          .catch(() => {});
      } else if (status == 2) {
        let that = this;
        this.$confirm("确定通过该审核吗?", "提示", { type: "info" })
          .then(() => {
            that.loading = true;
            let para = {
              token: localStorage.getItem("api_token"),
              outId: row.id,
              status: 2
            };
            API.up_cash_out(para)
              .then(
                function(result) {
                  that.loading = false;
                  if (result && parseInt(result.key) === 1000) {
                    that.$message.success({
                      showClose: true,
                      message: "通过成功",
                      duration: 1500
                    });
                    that.search();
                  }
                },
                function(err) {
                  that.loading = false;
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000
                  });
                }
              )
              .catch(function(error) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
          })
          .catch(() => {});
      }
    },
    formatterOrderStatus(row, column) {
      if (row.status == 1) {
        return "待支付";
      } else if (row.status == 2) {
        return "待发货";
      } else if (row.status == 3) {
        return "待收货";
      } else if (row.status == 4) {
        return "已完成";
      } else if (row.status == 5) {
        return "已取消";
      } else if (row.status == 7) {
        return "待自提";
      } else if (row.status == 8) {
        return "已自提";
      } else if (row.status == 9) {
        return "待补货";
      } else if (row.status == 10) {
        return "待支付";
      } else if (row.status == 11) {
        return "已完成";
      } else if (row.status == 12) {
        return "补货已过期";
      }
    },
    formatterStatus(row, column) {
      if (row.from_type == 1) {
        return "可提现金额";
      } else if (row.from_type == 2) {
        return "不可提现金额";
      }
    },
    get_group_user_count(type) {},

    selectAddress() {
      this.bankListVisible = true;
      let that = this;
      let params = {
        token: localStorage.getItem("api_token"),
        userId: this.userId
      };
      that.addVisibleLoading = true;
      API.user_address_list(params)
        .then(
          function(result) {
            that.addVisibleLoading = false;
            if (result.key == 1000) {
              that.tableData33 = result.result.list;
            }
          },
          function(err) {
            that.addVisibleLoading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.addVisibleLoading = false;
          console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },

    selectBank() {
      let that = this;
      let params = {
        id: this.userId,
        infoType: 2,
        page_num: that.page_num2Y,
        page_size: that.page_size2Y,
        token: localStorage.getItem("api_token")
      };
      that.listLoading2Y = true;
      API.score_user_list(params)
        .then(
          function(result) {
            that.listLoading2Y = false;
            if (result.key == 1000) {
              that.total_num2Y = result.result.count;
              that.total_page2Y = result.result.allPageNumber;
              if (result.result.list && result.result.list.length > 0) {
              }
              that.tableData2Y = result.result.list;
            }
          },
          function(err) {
            that.listLoading2Y = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.listLoadingY = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },

    handleSearch() {
      this.page_size11 = 10;
      this.page_num11 = 1;
      this.search();
    },
    search() {
      let that = this;
      let params = {
        userId: this.userId,
        pageNum: that.page_num11,
        scoreType: 2,
        pageSize: that.page_size11,
        token: localStorage.getItem("api_token")
      };
      if (that.filtersOut.endTime) {
        params.month = dateFunc.formatDate(that.filtersOut.endTime, "yyyy-MM");
      }
      that.listLoadingOut = true;
      API.score_record_list(params)
        .then(
          function(result) {
            that.listLoadingOut = false;
            if (result.key == 1000) {
              that.total_num11 = result.result.count;
              that.total_page11 = result.result.allPageNumber;
              if (result.result.list && result.result.list.length > 0) {
                for (var i = 0; i < result.result.list.length; i++) {
                  result.result.list[i].create_time_form = dateFunc.formatDate(
                    new Date(parseInt(result.result.list[i].create_time)),
                    "yyyy-MM-dd hh:mm:ss"
                  );
                  result.result.list[i].create_time_month = dateFunc.formatDate(
                    new Date(parseInt(result.result.list[i].create_time)),
                    "yyyy-MM"
                  );
                  if (result.result.list[i].other_info != null && result.result.list[i].other_info != '') {
                    result.result.list[i].other_info = JSON.parse(result.result.list[i].other_info)
                  }
                }
              }
              that.tableDataOut = result.result.list;
              that.outTotal = result.result.data;
            }
          },
          function(err) {
            that.listLoadingOut = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.listLoadingOut = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },

    //查询同级直属
    handleSearchYeji() {
      this.page_size1Y = 10;
      this.page_num1Y = 1;
      this.searchYeji();
    },
    searchYeji() {
      let that = this;
      let params = {
        id: this.userId,
        infoType: 1,
        page_num: that.page_num1Y,
        page_size: that.page_size1Y,
        token: localStorage.getItem("api_token")
      };
      that.listLoadingY = true;
      API.score_user_list(params)
        .then(
          function(result) {
            that.listLoadingY = false;
            if (result.key == 1000) {
              that.total_num1Y = result.result.count;
              that.total_page1Y = result.result.allPageNumber;
              if (result.result.list && result.result.list.length > 0) {
              }
              that.tableDataY = result.result.list;
            }
          },
          function(err) {
            that.listLoadingY = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.listLoadingY = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },

    handleSearchIn() {
      this.page_size1 = 10;
      this.page_num1 = 1;
      this.searchIn();
    },
    searchIn() {
      let that = this;
      let params = {
        userId: this.userId,
        pageNum: that.page_num1,
        pageSize: that.page_size1,
        token: localStorage.getItem("api_token")
      };
      if (that.filtersIn.status) {
        params.status = that.filtersIn.status;
      }
      if (that.filtersIn.startTime) {
        params.startTime = that.filtersIn.startTime.getTime();
      }
      if (that.filtersIn.endTime) {
        params.endTime = that.filtersIn.endTime.getTime();
      }

      that.listLoading = true;
      API.money_in_list(params)
        .then(
          function(result) {
            that.listLoading = false;
            if (result.key == 1000) {
              that.total_num1 = result.result.count;
              that.total_page1 = result.result.allPageNumber;
              if (result.result.list && result.result.list.length > 0) {
                // for (var i=0; i<result.list.length; i++)
                // {
                //   result.list[i].properties =
                // }
              }
              that.tableData = result.result.list;
              that.inTotal = result.result.data;
            }
          },
          function(err) {
            that.listLoading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.listLoading = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },

    handleSearchOrder() {
      this.page_size5 = 10;
      this.page_num5 = 1;
      this.searchOrder();
    },
    searchOrder() {
      let that = this;
      let params = {
        pageNum: that.page_num5,
        pageSize: that.page_size5,
        scoreType: 1,
        userId: this.userId,
        token: localStorage.getItem("api_token")
      };
      if (that.filtersOrder.endTime) {
        params.month = dateFunc.formatDate(
          that.filtersOrder.endTime,
          "yyyy-MM"
        );
      }
      that.listLoading4 = true;
      API.score_record_list(params)
        .then(
          function(result) {
            that.listLoading4 = false;
            if (result.key == 1000) {
              that.total_num5 = result.result.count;
              that.total_page5 = result.result.allPageNumber;
              if (result.result.list && result.result.list.length > 0) {
                for (var i = 0; i < result.result.list.length; i++) {
                  result.result.list[i].create_time_form = dateFunc.formatDate(
                    new Date(parseInt(result.result.list[i].create_time)),
                    "yyyy-MM-dd hh:mm:ss"
                  );
                  result.result.list[i].create_time_month = dateFunc.formatDate(
                    new Date(parseInt(result.result.list[i].create_time)),
                    "yyyy-MM"
                  );
                }
              }
              that.tableData4 = result.result.list;
              that.useTotal = result.result.data;
            }
          },
          function(err) {
            that.listLoading4 = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.listLoading4 = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },

    handleSearchGoodList() {
      this.page_size3G = 10;
      this.page_num3G = 1;
      this.searchGoodList();
    },
    searchGoodList() {
      let that = this;
      let params = {
        page_num: that.page_num3G,
        page_size: that.page_size3G,
        infoType: 2,
        id: this.userId,
        token: localStorage.getItem("api_token")
      };
      // if (that.filtersOrder.startTime) {
      //   params.startTime = that.filtersOrder.startTime.getTime();
      // }
      // if (that.filtersOrder.endTime) {
      //   params.endTime = that.filtersOrder.endTime.getTime();
      // }
      that.listLoading255 = true;
      API.score_user_list(params)
        .then(
          function(result) {
            that.listLoading255 = false;
            if (result.key == 1000) {
              that.total_num3G = result.result.count;
              that.total_page3G = result.result.allPageNumber;
              if (result.result.list && result.result.list.length > 0) {
                // for (var i = 0; i < result.result.list.length; i++) {
                //   result.result.list[i].create_time = dateFunc.formatDate(
                //     new Date(parseInt(result.result.list[i].create_time)),
                //     "yyyy-MM-dd hh:mm:ss"
                //   );
                // }
              }
              that.tableData2G = result.result.list;
            }
          },
          function(err) {
            that.listLoading255 = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.listLoading4 = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },

    handleSearchReward() {
      this.page_size3 = 10;
      this.page_num3 = 1;
      this.searchReward();
    },
    searchReward() {
      let that = this;
      let params = {
        pageNum: that.page_num3,
        pageSize: that.page_size3,
        userId: this.userId,
        token: localStorage.getItem("api_token")
      };
      if (that.filtersReward.startTime) {
        params.startTime = that.filtersReward.startTime.getTime();
      }
      if (that.filtersReward.endTime) {
        params.endTime = that.filtersReward.endTime.getTime();
      }
      if (that.filtersReward.orderType) {
        params.orderType = that.filtersReward.orderType;
      }
      that.listLoading2 = true;
      API.order_list(params)
        .then(
          function(result) {
            that.listLoading2 = false;
            if (result.key == 1000) {
              that.total_num3 = result.result.count;
              that.total_page3 = result.result.allPageNumber;
              if (result.result.list && result.result.list.length > 0) {
                for (var i = 0; i < result.result.list.length; i++) {
                  result.result.list[i].create_time = dateFunc.formatDate(
                    new Date(parseInt(result.result.list[i].create_time)),
                    "yyyy-MM-dd hh:mm:ss"
                  );
                }
              }
              that.tableData2 = result.result.list;
            }
          },
          function(err) {
            that.listLoading2 = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.listLoading2 = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },

    handleSearchGroup() {
      this.page_size2 = 10;
      this.page_num2 = 1;
      this.searchGroupCount();
      this.searchGroup();
    },
    searchGroupCount() {
      let that = this;
      let params = {
        pageNum: that.page_num2,
        pageSize: that.page_size2,
        userId: this.userId,
        roleType: this.stu.role_type,
        type: that.filtersGroup.type,
        token: localStorage.getItem("api_token")
      };
      API.group_count_total(params)
        .then(
          function(result) {
            that.listLoading1 = false;
            if (result.key == 1000) {
              that.groupMap = result.result.map;
            }
          },
          function(err) {
            that.listLoading1 = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.listLoading1 = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    searchGroup() {
      let that = this;
      let params = {
        pageNum: that.page_num2,
        pageSize: that.page_size2,
        userId: this.userId,
        token: localStorage.getItem("api_token")
      };
      if (that.filtersGroup.roleType && that.filtersGroup.roleType != null) {
        params.roleType = that.filtersGroup.roleType;
      }
      if (that.filtersGroup.type && that.filtersGroup.type != null) {
        params.type = that.filtersGroup.type;
      }
      if (that.filtersGroup.username) {
        params.username = that.filtersGroup.username;
      }
      that.listLoading1 = true;
      API.group_count_list(params)
        .then(
          function(result) {
            that.listLoading1 = false;
            if (result.key == 1000) {
              that.total_num2 = result.result.count;
              that.total_page2 = result.result.allPageNumber;
              if (result.result.list && result.result.list.length > 0) {
              }
              that.tableDataGroup = result.result.list;
            }
          },
          function(err) {
            that.listLoading1 = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.listLoading1 = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },

    pageBack() {
      this.$router.push({ path: "/my_score_list", query: { id: 1 } });
    },
    objectSpanMethod({ row, rowIndex }) {
      return "table_head";
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.search();
    },
    handleCurrentChangeReward(val) {
      this.searchReward();
    },
    handleCurrentChangeCangku(val) {
      this.searchGoodList();
    },
    handleCurrentChangeY(val) {
      this.searchYeji();
    },
    handleCurrentChangeIn(val) {
      this.searchIn();
    },
    handleCurrentChangeGroup(val) {
      this.searchGroup();
    },
    handleCurrentChangeOrde(val) {
      this.searchOrder();
    },
    handleClick(tab, event) {
      //selectAddress
      if (this.activeName == "second") {
        // this.get_group_user_count();
      } else if (this.activeName == "cangku") {
        this.handleSearchGoodList();
      } else if (this.activeName == "four_ua") {
        this.selectAddress();
      } else if (this.activeName == "third") {
        this.selectBank();
      } else if (this.activeName == "three") {
        this.handleSearchIn();
      } else if (this.activeName == "four") {
        this.handleSearch();
      } else if (this.activeName == "fifth") {
        this.handleSearchOrder();
      } else if (this.activeName == "six") {
        this.handleSearchReward();
      } else if (this.activeName == "seven") {
        // this.handleSearch();  我的团队
        this.handleSearchGroup();
      }
    }
  }
};
</script>

<style>
.el-container {
  overflow-y: auto;
}
.pageStudentDetail.el-main {
  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
  /* margin-left: 210px; */
  background-color: #f7f7f7;
  /* padding: 0; */
  display: flex;
  flex-direction: column;
}
.pageStudentDetail .navs {
  padding: 20px 20px;
  width: 100%;
  background-color: #fff;
}
.pageStudentDetail .clientContent {
  background-color: #f7f7f7;
  padding: 20px 20px 0px 20px;
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
}

.pageStudentDetail .clientContent .paraContent_body {
  /*background-color: #fff;*/
  padding-bottom: 0;
  height: 100%;
  width: 100%;
  overflow-y: auto;
  margin-left: 0;
}
.pageStudentDetail .stuDetailContent0 {
  padding-bottom: 20px;
  background-color: #f7f7f7;
}
.pageStudentDetail .stuDetailContent1 {
  display: flex;
  /*align-items: center;*/
  justify-content: flex-start;
  background-color: #fff;
}
.pageStudentDetail .stuDetailContent1 > div.userHead {
  width: 200px;
  padding: 20px;
  text-align: center;
}
.pageStudentDetail .userHead img {
  border-radius: 50%;
  width: 120px;
  height: 120px;
}
.pageStudentDetail .userHead img + div {
  margin: 10px 0 0 0;
}
.pageStudentDetail .stuDetailContent1 .userInfo {
  flex: 1;
  display: block;
  height: auto;
}
.pageStudentDetail .moreUserInfo ul {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
}
.pageStudentDetail .moreUserInfo li {
  color: #666;
  width: 33.3%;
}
.orderLi {
  padding-bottom: 15px;
}
.orderLi .orderLiTxt span + span {
  margin-left: 30px;
}
.color666 {
  color: #666;
}
.border-b {
  border-bottom: 1px solid #ededed;
}
.orderLi_content_1 {
  margin: 20px 0;
}
.orderLi_content_1 > span + span {
  margin-left: 30px;
}
.warmingTip {
  background-color: rgba(230, 247, 255, 1);
  border: 1px solid rgba(139, 209, 253, 1);
  padding: 10px 20px;
  border-radius: 3px;
}
.payBox {
  padding: 15px 30px;
}

.payBox li > div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  height: 50px;
}

.payBox li .payNum {
  display: flex;
  align-items: center;
  flex-direction: row;
}

.payBox li .colorGray span {
  color: #000;
  padding-right: 10px;
  font-size: 20px;
}
.signCourseContent .colorGray span {
  color: #000;
  padding-right: 10px;
  font-size: 20px;
}

.payBox li .colorGray span.payTotal {
  color: rgba(253, 166, 43, 1);
}
.signCourseContent .colorGray span.payTotal {
  color: rgba(253, 166, 43, 1);
}
.el-tag + .el-tag {
  margin-left: 20px;
}
.gapHeight {
  padding: 20px 0;
  border-bottom: 1px solid #ededed;
}
.handleMsg {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 20px;
}
.handleMsg > div {
  width: 50%;
  margin: 15px 0;
}
.pageStudentDetail .backPage {
  margin: 20px 0 0 20px;
}
.color999 {
  color: #999;
}
.colorC {
  color: #ccc;
}
.fontWidth {
  width: 140px;
  display: inline-block;
  text-align: right;
}
.pageStudentDetail .baseUserInfo {
  border-bottom: 1px solid #ededed;
  padding-bottom: 10px;
}
.pageStudentDetail .baseUserInfo .base_label {
  color: #000;
  font-size: 18px;
  font-weight: bold;
  margin-top: 20px;
}
.baseUserInfo > div {
  line-height: 40px;
}
.moreUserInfo .base_label {
  color: #000;
  font-size: 18px;
  font-weight: bold;
  margin: 15px 0;
}
.moreUserInfo ul li {
  line-height: 30px;
}
.stuDetailContent2 {
  margin-top: 0px;
  background-color: #fff;
}
.el-tabs__nav-wrap {
  padding: 0 30px;
}
.el-tabs__content {
  padding: 0 0 20px 0;
}

.pageStudentDetail .clientSection2 {
  margin-top: 22px;
}
.pageStudentDetail .el-form-item {
  margin-bottom: 10px;
}
.el-dialog__header {
  background-color: #2593fc;
}

.el-dialog__title {
  color: #fff;
  font-size: 16px;
}

.el-dialog__body {
  border: 1px solid rgba(237, 237, 237, 1);
}

.rightBtn {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.data-count-div {
  margin: 0 10px 20px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.data-count-div-left {
  border: 1px solid rgb(212, 211, 211);
  border-radius: 10px;
  padding: 20px;
  width: 69%;
}
.data-count-div-right {
  border: 1px solid rgb(212, 211, 211);
  border-radius: 10px;
  padding: 20px;
  width: 30%;
}
.title-left-s {
  display: inline-block;
  width: 10px;
  background-color: aqua;
  height: 20px;
  margin-right: 10px;
}
.center-data-boy {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
}
.center-data-boy > div {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.data-count-div-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.data-count-div .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 150px;
}
</style>



// WEBPACK FOOTER //
// src/components/user/score_detail.vue